// removed by extract-text-webpack-plugin
module.exports = {"container":"TabItem__container-o5I9N"};